import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { axiosInstance } from '../api/api';
import { onSuccess, Method, MutationObject, Config, Body } from './shared';

const createMutation = (method: Method) => <T>(config: Config = {}): UseMutationResult<T, Error, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation<T, Error, any, unknown>(async (data: MutationObject | Body): Promise<T> => {
    const path = typeof data?.path === 'string' ? data.path : config.path;
    const payload = typeof data?.path === 'string' ? data.body : data;
    const result = await axiosInstance()[method](path as string, payload);
    return result.data as T;
  }, { onSuccess: onSuccess.bind(null, queryClient, config) });
};

export const usePostMutation = createMutation(Method.POST);
export const usePutMutation = createMutation(Method.PUT);
export const useDeleteMutation = createMutation(Method.DELETE);
